<template>
  <span>{{ formattedDate }}</span>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "FormattedDate",
  props: {
    date: {
      type: [String, Date],
      required: true,
    },
    formatString: {
      type: String,
      default: "yyyy-MM-dd HH:mm",
    },
  },
  computed: {
    formattedDate() {
      if (!this.date) return "";
      try {
        return format(new Date(this.date), this.formatString);
      } catch (error) {
        console.error("Error formatting date:", error);
        return this.date;
      }
    },
  },
};
</script>
